import store from "@frameworks/web/redux/store/index";
import { SAVEPROFILEPIC, SAVEPROFILEPIC_ERROR, SAVEPROFILEPIC_HIDE_ERROR, SAVEPROFILEPIC_START_LOADER, SAVEPROFILEPIC_STOP_LOADER } from "../interface/IsaveProfilePic";
class SaveProfilePicActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    saveProfilePicData(data) {
        this.dispatch({
            type: SAVEPROFILEPIC,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: SAVEPROFILEPIC_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: SAVEPROFILEPIC_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: SAVEPROFILEPIC_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: SAVEPROFILEPIC_STOP_LOADER,
        });
    }
}
export default SaveProfilePicActions;
